<script>
import { mapActions } from "pinia";
import { newsStore } from "@/store/newsStore";

export default {
  props: {
    news: {
      type: Object,
    },
  },
  methods: {
    ...mapActions(newsStore, ['updateConsolidatedNewsList'])
  },
};
</script>

<template>
  <div>
    {{news.textParams[0]}} {{$t('news.template.elected.val.new.consolidated.p1')}}
  </div>
</template>
